import {Component} from '@angular/core';

@Component({
  selector: 'app-gvp',
  templateUrl: './gvp.component.html'
})
export class GvpComponent {

}
